import { render, staticRenderFns } from "./CollectionDepartmentList.vue?vue&type=template&id=13f742e1"
import script from "./CollectionDepartmentList.vue?vue&type=script&lang=js"
export * from "./CollectionDepartmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports